import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { BSG_LOGO_URL, BSG_SITE_URL } from "../lib/brand";

export const SiteHeader = ({ variant = "group", showNav = false }) => {
  const location = useLocation();

  return (
    <header
      className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-[#cfd7db]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 lg:px-16 py-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 md:gap-6 min-w-0 flex-wrap">
          <Link to="/" data-testid="header-logo-link" className="shrink-0">
            <Logo variant={variant} size="md" />
          </Link>
          {/* Partnership badge — Proud Distributor of BSG Auto Glass */}
          <a
            href={BSG_SITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="bsg-partner-badge"
            className="flex items-center gap-2 sm:pl-4 sm:border-l border-[#cfd7db] hover:opacity-80 transition"
            title="Visit BSG Auto Glass"
          >
            <div className="hidden sm:flex flex-col leading-tight">
              <span className="font-display uppercase tracking-widest text-[10px] text-[#3f4b52]">
                Proud Distributor of
              </span>
              <span className="font-display font-bold text-xs text-[#111619]">
                BSG Auto Glass
              </span>
            </div>
            <img
              src={BSG_LOGO_URL}
              alt="BSG Auto Glass"
              className="h-8 sm:h-10 w-auto object-contain"
            />
          </a>
        </div>

        {showNav && (
          <nav className="hidden md:flex items-center gap-8 font-display uppercase tracking-widest text-sm">
            <a
              href="#services"
              className="text-[#29353b] hover:text-[#f28a16] transition"
              data-testid="nav-services"
            >
              Services
            </a>
            <a
              href="#coverage"
              className="text-[#29353b] hover:text-[#f28a16] transition"
              data-testid="nav-coverage"
            >
              Coverage
            </a>
            <a
              href="#quote"
              className="text-[#29353b] hover:text-[#f28a16] transition"
              data-testid="nav-quote"
            >
              Get a Quote
            </a>
            <Link
              to="/"
              className="text-[#3f4b52] hover:text-[#111619] transition"
              data-testid="nav-back-home"
            >
              ← Group Home
            </Link>
          </nav>
        )}

        {!showNav && location.pathname !== "/" && (
          <Link
            to="/"
            className="font-display uppercase tracking-widest text-xs text-[#3f4b52] hover:text-[#f28a16] transition"
            data-testid="header-back-home"
          >
            ← Back
          </Link>
        )}
      </div>
    </header>
  );
};

export default SiteHeader;
